/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the highest YouTube thumbnail resolution?`)
};

const es_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la resolución máxima de miniatura de YouTube?`)
};

const de_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche ist die höchste YouTube-Thumbnail-Auflösung?`)
};

const nl_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de hoogste YouTube-thumbnailresolutie?`)
};

const fr_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la résolution maximale d’une miniature YouTube ?`)
};

const it_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la risoluzione massima delle miniature YouTube?`)
};

const pt_br2_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a maior resolução de thumbnail do YouTube?`)
};

const pt_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a resolução mais alta de miniatura do YouTube?`)
};

const ja_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeサムネイルの最高解像度は？`)
};

const zh_yt_hd_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 缩略图的最高分辨率是多少？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_faq1_q", locale)
	if (locale === "en") return en_yt_hd_faq1_q(inputs)
	if (locale === "es") return es_yt_hd_faq1_q(inputs)
	if (locale === "de") return de_yt_hd_faq1_q(inputs)
	if (locale === "nl") return nl_yt_hd_faq1_q(inputs)
	if (locale === "fr") return fr_yt_hd_faq1_q(inputs)
	if (locale === "it") return it_yt_hd_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_faq1_q(inputs)
	if (locale === "pt") return pt_yt_hd_faq1_q(inputs)
	if (locale === "ja") return ja_yt_hd_faq1_q(inputs)
	return zh_yt_hd_faq1_q(inputs)
};